import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'api-key-table',
  templateUrl: './api-key-table.component.html',
  styleUrls: ['./api-key-table.component.css']
})
export class ApiKeyTableComponent implements OnInit {
   
  
  @Input() data;
  @Input() tabledata;
  constructor() { }

  ngOnInit() {
  }

}
